module.exports = __webpack_public_path__ + "static/media/bed_new_pack_cat_EN_285x285.a2b730e3.png";